<template>
  <div>
    <div class="boxShell">
      <i class="iconfont icon-chenggong-icon topicon"></i>
      <p class="tip">电核成功</p>
      <Button
        :loading="Isloading"
        :disabled="Isloading"
        :text="draw"
        :type="danger"
        class="nextStep"
        :click="goToNextPage"
      />
    </div>
    <server-bank :productId="this.$route.query.productId"></server-bank>
  </div>
</template>
<script>
import Button from '@/components/Button.vue';
import ServerBank from '@/components/ServerBank.vue';
import { checkStatus } from './mixin';

export default {
  name: 'IdentifySuccess',
  data() {
    return {
      danger: 'danger',
      draw: '下一步',
      Isloading: false,
    };
  },
  mixins: [checkStatus],
  components: {
    Button,
    ServerBank,
  },
  methods: {
    goToNextPage() {
      this.Isloading = true;
      setTimeout(() => {
        this.Isloading = false;
      }, 2000)
      this.$store.dispatch('commonForms/nextJumpPage', {
        orderId: localStorage.getItem('orderId'),
      });
    },
  },
};
</script>
<style scoped>
.boxShell {
  padding-top: 103px;
}
.topicon {
  margin-top: 103px;
  color: #ff6538;
  font-size: 60px;
}
.tip {
  color: #1c2438;
  font-size: 17px;
  text-align: center;
}
.nextStep {
  margin-top: 100px;
  margin-bottom: 7px;
}
</style>
